import * as user from './ducks/user';

const ducks = { user };

export { ducks };
export { default as useUser } from './hooks/useUser';
